import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SIZES } from '../../sizes';
import logo from '../../assets/logo.svg'
//import logoMobile from '../../logomobile.svg'
import { LinkButton } from './LinkButton'


export function MainNav({ handleMenuToggle, isMenuToggled }) {

    const [openDropdown, setOpenDropdown] = useState(null);
    function toggleMenu() {
        //console.log(e)
        if (!SIZES.isMobileDevice()) return;

        var x = document.getElementById("MainNav");
        handleMenuToggle(!isMenuToggled);
        //console.log("class: ", x.className)
        //console.log("isMenuClick: ", isMenuClick)
        if (!isMenuToggled) {
            document.body.classList.add("has-active-nav-toggle");
        } else {
            document.body.classList.remove("has-active-nav-toggle");
        }


        //if (x.className === "page-header__nav") {
        //    x.className += " page-header__nav--open";
        //    handleMenuToggle(true)
        //} else {
        //    x.className = "page-header__nav";
        //    handleMenuToggle(false)
        //}


    }

    function toggleDropdown(e, menuItem) {
        if (SIZES.isMobileDevice()) {

            e.preventDefault(); // ? stop navigation
            setOpenDropdown(openDropdown === menuItem ? null : menuItem);

            //var x = document.getElementById(e.target.id + "-dropdown")
            //if (x) {
            //    if (x.className == 'c-topnav__dropdown-button') {
            //        x.className += ' c-topnav__dropdown-button--open';
            //    } else {
            //        x.className = 'c-topnav__dropdown-button';
            //    }
            //}
        }
    }
    return (
        <div className="page-header__inner">

            <div className="page-header__logo">

                <Link to="/"><img src={logo} alt="logo" /></Link>
            </div>
            <nav id="MainNav" className="main-nav">

                <ul className="main-nav__list">
                    <li className="main-nav__list-item" >
                        <a href="/" className={
                            openDropdown === "ciphers"
                                ? "main-nav__link main-nav__link--active"
                                : "main-nav__link"
                        }>
                            <span className="main-nav__link-label">
                                Home
                            </span>
                        </a>
                    </li>
                    <li className="main-nav__list-item">
                        <a href="/cipher-tools" className={
                            openDropdown === "ciphers"
                                ? "main-nav__link main-nav__link--active"
                                : "main-nav__link"
                        } onClick={(event) => toggleDropdown(event, "ciphers")}>
                            <span className="main-nav__link-label">
                                Ciphers
                            </span>
                            <FontAwesomeIcon icon="fa fa-caret-down" />
                        </a>
                        <div className={
                            openDropdown === "ciphers"
                                ? "main-nav__sub main-nav__sub--open"
                                : "main-nav__sub"
                        }>
                            <div className="main-nav__sub-inner">
                                <ul className="main-nav__sub-list">
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/caesar-cipher'>
                                            <span className="main-nav__sub-link-label">Caesar Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/vigenere-cipher'>
                                            <span className="main-nav__sub-link-label">Vigenere Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/morse-code'>
                                            <span className="main-nav__sub-link-label">Morse Code</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/polybius-cipher'>
                                            <span className="main-nav__sub-link-label">Polybius Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/playfair-cipher'>
                                            <span className="main-nav__sub-link-label">Playfair Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/porta-cipher'>
                                            <span className="main-nav__sub-link-label">Porta Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/rail-cipher'>
                                            <span className="main-nav__sub-link-label">Rail Cipher</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/cipher-tools/jump-cipher'>
                                            <span className="main-nav__sub-link-label">Jump Cipher</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </li>
                    <li className="main-nav__list-item">
                        <a href="/text-tools" className={
                            openDropdown === "text"
                                ? "main-nav__link main-nav__link--active"
                                : "main-nav__link"
                        } onClick={(event) => toggleDropdown(event, "text")}>
                            <span className="main-nav__link-label">
                                Text
                            </span>
                            <FontAwesomeIcon icon="fa fa-caret-down" />
                        </a>
                        <div className={
                            openDropdown === "text"
                                ? "main-nav__sub main-nav__sub--open"
                                : "main-nav__sub"
                        }>
                            <div className="main-nav__sub-inner">
                                <ul className="main-nav__sub-list">
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/analyse-frequency'>
                                            <span className="main-nav__sub-link-label">Frequency Analysis</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/manipulate-text'>
                                            <span className="main-nav__sub-link-label">Manipulate Text</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/preprocess-text'>
                                            <span className="main-nav__sub-link-label">Preprocess Text</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/compare-text'>
                                            <span className="main-nav__sub-link-label">Compare Text</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/split-text'>
                                            <span className="main-nav__sub-link-label">Split Text</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/join-text'>
                                            <span className="main-nav__sub-link-label">Join Text</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/extract-tokens'>
                                            <span className="main-nav__sub-link-label">Extract Tokens</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/extract-css'>
                                            <span className="main-nav__sub-link-label">Extract CSS</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/text-tools/text-statistics'>
                                            <span className="main-nav__sub-link-label">Text Statistics</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </li>
                    <li className="main-nav__list-item">
                        <a href="/misc-tools" className={
                            openDropdown === "misc"
                                ? "main-nav__link main-nav__link--active"
                                : "main-nav__link"
                        } onClick={(event) => toggleDropdown(event, "misc")}>
                            <span className="main-nav__link-label">
                                Misc
                            </span>
                            <FontAwesomeIcon icon="fa fa-caret-down" />
                        </a>
                        <div className={
                            openDropdown === "misc"
                                ? "main-nav__sub main-nav__sub--open"
                                : "main-nav__sub"
                        }>
                            <div className="main-nav__sub-inner">
                                <ul className="main-nav__sub-list">
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/misc-tools/convert-encodings'>
                                            <span className="main-nav__sub-link-label">Convert Encodings</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/misc-tools/convert-color'>
                                            <span className="main-nav__sub-link-label">Convert Color</span>
                                        </NavLink>
                                    </li>
                                    <li className="main-nav__sub-list-item">
                                        <NavLink onClick={() => toggleMenu()} className={({ isActive }) => isActive ? "main-nav__sub-link main-nav__sub-link--active" : "main-nav__sub-link"} to='/misc-tools/convert-15-to-18'>
                                            <span className="main-nav__sub-link-label">Convert Salesforce ID</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </li>

                </ul>

            </nav>



            <div className="page-header__actions">


                <LinkButton link="https://www.buymeacoffee.com/kamilko" icon='fas fa-coffee' tooltipTitle="Support the site!" variant="header" />
                <LinkButton link="mailto: ciphercentreweb@gmail.com" icon='fas fa-envelope' tooltipTitle="Send me a message!" variant="header" />


                <div id="menu-dropdown"
                    className={`nav-toggle d-flex d-md-none ${isMenuToggled ? 'nav-toggle--active' : ''}`}
                    onClick={() => toggleMenu()}>{/*<FontAwesomeIcon icon={isMenuToggled ? "fas fa-times" : "fas fa-bars"} className="" size="large" />*/}
                    <div className="nav-toggle__inner">
                        <span className="nav-toggle__bar nav-toggle__bar--top"></span>
                        <span className="nav-toggle__bar nav-toggle__bar--middle"></span>
                        <span className="nav-toggle__bar nav-toggle__bar--bottom"></span>
                    </div>


                </div>
            </div>
        </div>

    )
}
